import React, { useRef, useState, SyntheticEvent } from 'react';

import { ButtonColorTokenProp } from '../../../theme/tokens/button-color';

import { NonContentfulWidgetProps, InputProps } from '../shared';

import {
  GetStartedInput,
  GetStartedButton,
  GetStartedWrapper
} from './LegacyGetStartedWidget.styles';

interface LegacyGetStartedWidgetProps extends NonContentfulWidgetProps {
  onStartClick?: () => void;
  inputProps?: InputProps;
}

export function LegacyGetStartedWidget({
  buttonColor = 'dark',
  buttonHoverColor = 'light',
  cfButtonColor,
  cfButtonHoverColor,
  onStartClick,
  inputProps
}: LegacyGetStartedWidgetProps) {
  const [isStartClicked, setIsStartClicked] = useState(false);
  const getStartInputRef = useRef<any>();

  const handleStartClick = (e: SyntheticEvent) => {
    e.preventDefault();
    setIsStartClicked(true);
    onStartClick && onStartClick();
    return getStartInputRef?.current?.element?.focus();
  };

  const btnProps = !isStartClicked ? { onClick: handleStartClick } : {};
  const tabIndex = isStartClicked ? 0 : -1;

  return (
    <GetStartedWrapper>
      <GetStartedInput
        ref={getStartInputRef}
        isStartClicked={isStartClicked}
        tabIndex={tabIndex}
        data-testid="get-started-cta-v1"
        {...(inputProps as InputProps)}
      />
      <GetStartedButton
        type="submit"
        showIcon={isStartClicked}
        buttonColor={buttonColor as ButtonColorTokenProp}
        buttonHoverColor={buttonHoverColor as ButtonColorTokenProp}
        cfButtonColor={cfButtonColor}
        cfButtonHoverColor={cfButtonHoverColor}
        aria-label="Get started"
        data-testid="get-started-button"
        {...btnProps}
      >
        Get started
      </GetStartedButton>
    </GetStartedWrapper>
  );
}
